import buildQuery from "odata-query";
import { ODataQuery } from "./types";

export function getODataSearchParams(query: ODataQuery<any> | undefined) {
  return new URLSearchParams(buildQuery(query ?? {}));
}

export function buildODataQueryString(
  query: ODataQuery<any> | undefined,
): string {
  const search = getODataSearchParams(query).toString();
  return search && `?${search}`;
}

export function buildODataFilter(query: ODataQuery<any> | undefined) {
  const searchParams = getODataSearchParams(query);
  const filter = searchParams.get("$filter") ?? "";
  return filter;
}
